<template>
  <div class="slit-diffraction-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>a sinθ = kλ | Δx ≈ Lλ / a$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Barrier with Slit -->
          <rect x="50" y="20" width="10" height="90" fill="#888" />
          <rect x="50" y="20 + 90 + slitWidth" width="10" height="90" fill="#888" />
          
          <!-- Incoming Waves -->
          <line v-for="n in 5" :key="'w'+n" :x1="10 + n*8" y1="40" :x2="10+n*8" y2="200" stroke="rgba(0, 210, 255, 0.2)" />

          <!-- Diffraction Pattern to Screen -->
          <g v-if="powerOn">
             <!-- Rays to fringes -->
             <path v-for="k in maxima" :key="'m'+k" :d="calcRayPath(k)" fill="none" :stroke="color" :opacity="1 - Math.abs(k)*0.4" stroke-width="2" />
          </g>

          <!-- Intensity Graph on Screen -->
          <path :d="intensityPath" fill="none" :stroke="color" stroke-width="1.5" opacity="0.6" />
          
          <!-- Slit Width Indicator -->
          <text x="35" y="115" fill="#888" font-size="8" transform="rotate(-90, 35, 115)">缝宽 a</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>中央明纹宽度 Δx ∝ 1/a</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>调节缝宽 a: {{ slitWidth }} px</label>
             <el-slider v-model="slitWidth" :min="5" :max="40" size="mini"></el-slider>
          </div>
          <div class="row">
             <label>波长 λ (颜色): {{ wavelength }} nm</label>
             <el-slider v-model="wavelength" :min="400" :max="700" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>当光通过狭缝时，衍射现象使光不再直线传播。**缝越窄，中央明纹越宽**、衍射越明显。中央明纹宽度是两侧暗纹距离，集中了绝大部分的光能。这展示了光的波动性和海森堡不确定关系的宏观体现。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WaveDiffractionSlitViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      slitWidth: 20,
      wavelength: 550,
      powerOn: true
    }
  },
  computed: {
    color() {
       if (this.wavelength < 450) return '#8b00ff';
       if (this.wavelength < 495) return '#0000ff';
       if (this.wavelength < 570) return '#00ff00';
       if (this.wavelength < 590) return '#ffff00';
       if (this.wavelength < 620) return '#ffa500';
       return '#ff0000';
    },
    maxima() { return [-2, -1, 0, 1, 2]; },
    intensityPath() {
      let d = "M 350 20 ";
      for (let y = 20; y <= 220; y += 1) {
        let alpha = (Math.PI * (this.slitWidth/40) * (y - 120)) / (this.wavelength/100);
        let intensity = alpha === 0 ? 80 : 80 * Math.pow(Math.sin(alpha)/alpha, 2);
        d += `L ${350 + intensity} ${y} `;
      }
      return d;
    }
  },
  methods: {
    calcRayPath(k) {
      let yEnd = 120 + k * (500 / this.slitWidth) * (this.wavelength / 100);
      return `M 60 110 L 350 ${yEnd}`;
    }
  }
}
</script>

<style scoped lang="scss">
.slit-diffraction-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; 
  label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } 
}
.discovery-note { background: rgba(139, 0, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
